import { render, staticRenderFns } from "./TourVirtual.vue?vue&type=template&id=0ffc6989&scoped=true"
import script from "./TourVirtual.vue?vue&type=script&lang=ts"
export * from "./TourVirtual.vue?vue&type=script&lang=ts"
import style0 from "./TourVirtual.vue?vue&type=style&index=0&id=0ffc6989&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffc6989",
  null
  
)

export default component.exports